import React from "react";
import '../Common.scss';
import './PlanView.scss';
import defaultImage from '../../../assets/default.png';
export default class PlanView extends React.Component<any, any>{

    render() {
        const { pageDetails } = this.props;
        const measuredPlanImageUrl  = pageDetails?.measuredPlanImageUrl;
        const planDetails = pageDetails?.carcaseDetails || {};
        return (
            <div className="plan-view-page">
                <div className="page-image-container">
                    <div className="page-heading">{pageDetails?.name}</div>
                    <div className="image-section-container">
                        <img crossOrigin="anonymous"  src={measuredPlanImageUrl ? `${measuredPlanImageUrl}?ver=${new Date().getTime()}`: defaultImage} alt="" className="image-view" />
                    </div>
                </div>
                <div className="details-tables">
                    <div className="table-header">
                        <div className="details-heading-wrapper details-heading">
                            CARCASS SPECIFICATIONS
                            {/* <div className="details-heading-subtext">(*Current data is set as per global material settings)</div> */}
                        </div>
                        <div className="details">
                            {
                                planDetails && Object.keys(planDetails).map((key, index) => {
                                    const details = planDetails[key];
                                    let valueExist = false;
                                    if(Array.isArray(details) && details.length > 0){
                                        valueExist = true
                                    }else{
                                        if(Object.keys(details).length){
                                            valueExist = (Object.keys(details).length ===1 && Object.keys(details)[0] === "heading" ) ? false: true;
                                        }
                                    }
                                    let heading = details['heading'];
                                    if (key.includes("HANDLES") && details.length > 0)
                                        heading = "HANDLES"
                                    return (valueExist ? <React.Fragment>
                                        <div className={`details-table ${ key.includes('HANDLES')?"handle-table":""}`}>
                                            <div className="table-heading">
                                                     {heading || key?.split('_')[0]}
                                            </div>

                                            {
                                                key.includes('HANDLES') && details.length > 0 ?  <div className="table-row">
                                                    <div className="table-cell color-heading handle-name">Item</div>
                                                    {/* <div className="table-cell color-heading">CODE</div> */}
                                                    <div className="table-cell color-heading">Size</div>
                                                    {/* <div className="table-cell color-heading">PITCH(mm)</div> */}
                                                    <div className="table-cell color-heading">Type</div>
                                                    <div className="table-cell color-heading">Image</div>
                                                    <div className="table-cell color-heading">Budget</div>
                                                </div> : key.includes('PROFILE') && details.length > 0 ? <div className="table-row">
                                                    <div className="table-cell color-heading handle-name">Name</div>
                                                    <div className="table-cell color-heading">Type</div>
                                                    <div className="table-cell color-heading">Image</div> 
                                                </div> : <div className="table-row">
                                                    <div className="table-cell color-heading">Material</div>
                                                    <div className="table-cell color-heading">Color</div>
                                                    <div className="table-cell color-heading material-code">RefCode</div>
                                                </div>
                                            }
                                            {
                                                Array.isArray(details)  ?
                                                    details.map((arrObj, index) => {
                                                        return (
                                                            <React.Fragment>
                                                                {
                                                                    key.includes("HANDLES") ? <div className="table-row">
                                                                    <div className="table-cell handle-name">{arrObj['item']}</div>
                                                                    {/* <div className="table-cell">{arrObj['code']}</div> */}
                                                                    <div className="table-cell">{arrObj['size']}</div>
                                                                    {/* <div className="table-cell">{arrObj['pitch']}</div> */}
                                                                    <div className="table-cell">{arrObj['partType']}</div>
                                                                    <div className="table-cell handle-image-cell">
                                                                        <img crossOrigin="anonymous"  className='handle-image' alt=""
                                                                            src={`https://diqo3k74ktdb.cloudfront.net${arrObj['image']}?ver=${new Date().getTime()}` || defaultImage} />
                                                                    </div>
                                                                    <div className="table-cell">{arrObj['budgetType'] || "NA"}</div>
                                                                </div>: key.includes("PROFILE") ? <div className="table-row">
                                                                    <div className="table-cell handle-name">{arrObj['name'] || '-'}</div>
                                                                    <div className="table-cell">{arrObj['type'] || '-'}</div>
                                                                    <div className="table-cell handle-image-cell">
                                                                        <img crossOrigin="anonymous"  className='handle-image' alt=""
                                                                            src={arrObj['image'] || defaultImage} />
                                                                    </div>
                                                                    </div>: <div className="table-row">
                                                                    <div className="table-cell">{arrObj['carcassMaterial']}</div>
                                                                    <div className="table-cell">{arrObj['carcassColor']}</div>
                                                                    <div className="table-cell material-code">{arrObj['carcassColorCode']}</div>
                                                                </div>
                                                                }
                                                            </React.Fragment>
                                                        );
                                                    })
                                                    : Object.keys(details).map((key, index) => {
                                                        if (key !== "heading") {
                                                            return (
                                                                <React.Fragment>
                                                                    <div className="table-row">
                                                                        {
                                                                            typeof details[key] === 'object' && details[key] != null ? <React.Fragment>
                                                                            <div className="table-cell">
                                                                            {details[key]['name'].toUpperCase()}
                                                                        </div>
                                                                        <div className="table-cell">
                                                                            {details[key]['value'].toString().toUpperCase() || "NA"}
                                                                        </div></React.Fragment> :<React.Fragment> <div className="table-cell">
                                                                            {key.toUpperCase()}
                                                                        </div>
                                                                        <div className="table-cell">
                                                                            {details[key] ? details[key].toString().toUpperCase() : "NA"}
                                                                        </div></React.Fragment>
                                                                        }
    
                                                                    </div>
                                                                </React.Fragment>
                                                            );
                                                        }
                                                        return key;
                                                    })
                                            }

                                        </div>
                                    </React.Fragment>: "")

                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}